import React from "react";
import styles from "./index.module.scss";
import Footer from "../../Footer";
import Header from "../../Header";
import TabBar from "../../TabBar";
import PlatformWrap from "../../PlatformWrap";
import useDeviceType from "../../../Utils/useDeviceType";
import Boundary from "../../Boundary";

interface TopLayoutProps {
    children: React.ReactNode;
}

export function TopLayout({ children }: TopLayoutProps) {
    const { isMobile } = useDeviceType();

    return (
        <div className={styles.root}>
            <Header />

            <div className={styles.body}>
                <Boundary>{children}</Boundary>
            </div>

            {isMobile && <TabBar />}

            <PlatformWrap pc={<Footer />} />
        </div>
    );
}
